exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".wrapper-input-edit-able{position:relative}.wrapper-input-edit-able .input-edit-able{font-size:13px;padding:1px 0;border-radius:4px;position:absolute;z-index:10}.wrapper-input-edit-able .input-edit-able .fa{width:25px}.wrapper-input-edit-able .bottom{bottom:-25px}.wrapper-input-edit-able .top{top:-25px}.wrapper-input-edit-able .input-edit-able-save{right:1px}.wrapper-input-edit-able .input-edit-able-cancel{right:34px}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/components/inputEditAble/styles.scss
// module id = 1872
// module chunks = 33